import {DriversLicenseTypeItem} from "./DriversLicenseTypeItem";

export class DriverLicenseDetails {
  public driversLicenseTypeList: DriversLicenseTypeItem[] = [new DriversLicenseTypeItem()];
}
